<p class="description" [class.description-centered]="centered">
  <ng-content></ng-content>
</p>
